import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { StyleSheet, breakPoint, css } from '@coursera/coursera-ui';

import { logo } from 'bundles/coursera-plus/utils/courseraPlusUtils';

import _t from 'i18n!nls/coursera-plus-landing-page';

const styles = StyleSheet.create({
  logo: {
    height: '30px',
    marginBottom: '17px',
    [`@media (max-width: ${breakPoint.lg - 1}px)`]: {
      height: '23px',
      marginBottom: '20px',
    },
  },
});

const CourseraLiteLogo = () => {
  return (
    <div>
      <Imgix {...css(styles.logo)} src={logo.LITE_FULL_BLUE_HD} alt={_t('Coursera Lite')} maxHeight={42} />
    </div>
  );
};

export default CourseraLiteLogo;
